module.exports = __webpack_public_path__ + "static/media/contact_banner.1b66fae6.jpg";